import { render, staticRenderFns } from "./home-view.vue?vue&type=template&id=6bf231d2&scoped=true"
import script from "./home-view.vue?vue&type=script&lang=js"
export * from "./home-view.vue?vue&type=script&lang=js"
import style0 from "./home-view.vue?vue&type=style&index=0&id=6bf231d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf231d2",
  null
  
)

export default component.exports